import { EventEmitter } from 'events'

export class LineSaver extends EventEmitter {
  constructor (store, lines, opts) {
    super()
    this.store = store
    this.lineType = opts.lineType
    this.trxId = opts.trxId
    this.lines = lines || []
    this.failedLines = []
    this.savedLines = []
    this.completedRequests = 0
    this.totalRequests = 0
    this.isSaving = false
    this.attempt = 0
  }

  async saveLines () {
    try {
      const batch = this.lines.splice(0, 10).map(line => {
        let form = Object.assign({}, line.form || line)
        return this.store.dispatch('saveLine', {type: `${this.lineType}s`, id: this.trxId, line: form})
          .then(r => {
            if (r && r.response && r.response.id) this.completedRequests++
            return r
          })
      })
      const resp = await Promise.all(batch)
      if (!(resp && resp.length)) {
        throw new Error('Lines not saved: no response')
      }
      resp.forEach(v => {
        if (!v.response || (!v.response.id && v.response.hasOwnProperty('ok') && !v.response.ok)) {
          this.failedLines.push(v)
        } else {
          this.savedLines.push(v.response.id)
        }
      })
      return this.lines.length ? this.saveLines() : this.verifySaveSuccess()
    } catch (e) {
      console.log(e)
      this.emit('failure')
      this.isSaving = false
    }
  }

  verifySaveSuccess () {
    this.attempt = this.attempt += 1
    if (this.failedLines.length > 0 && this.attempt < 2) {    // Failed lines exist. Try to save those again
      this.lines = this.failedLines
      this.failedLines = []
      this.saveLines()
    } else if (this.failedLines.length > 0 && this.attempt >= 2) {  // Failed lines still exist. Emit failure event
      this.emit('failure')
    } else {                                                  // Looks like all lines saved. Do something.
      this.emit('success')
      this.attempt = 0
    }
  }
}
